module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module id = ./src/app/theme/components/baMenu/components/baMenuItem/baMenuItem.scss
// module chunks = main